import { render, staticRenderFns } from "./InfoCircleFill.vue?vue&type=template&id=e048866a"
import script from "./InfoCircleFill.vue?vue&type=script&lang=js"
export * from "./InfoCircleFill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports